<!--
 * @Description: 免費趣味測試 — 單個卡片
-->
<template>
	<li class="fun-test-card" @click="$emit('click')">
		<div class="fun-test-card__media">
			<img :src="cover" :alt="title" loading="lazy" />
		</div>
		<p class="fun-test-card__title">{{ title }}</p>
	</li>
</template>

<script setup>
defineProps({
	cover: {
		type: String,
		required: true,
	},
	title: {
		type: String,
		required: true,
	},
});

defineEmits(["click"]);
</script>

<style lang="scss" scoped>
.fun-test-card {
	display: flex;
	flex-direction: column;
	align-items: center;
	min-width: 0;
	padding: 10px;
	background-color: #ffffff;
	border-radius: 8px;
	border: 1px solid #ececec;
	box-sizing: border-box;
	cursor: pointer;
	transition: box-shadow 0.2s ease;

	&:hover {
		box-shadow: 0 4px 12px rgba(51, 51, 51, 0.08);
	}

	.fun-test-card__media {
		width: 100%;
		aspect-ratio: 1 / 1;
		border-radius: 8px;
		overflow: hidden;
		display: flex;
		align-items: center;
		justify-content: center;

		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
	}

	.fun-test-card__title {
		margin-top: 10px;
		width: 100%;
		font-weight: 500;
		font-size: 14px;
		color: #333333;
		line-height: 20px;
		text-align: center;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
		text-overflow: ellipsis;
	}
}
</style>
